export const Occupational_Injury_Insurance_EffectiveDate = '2022/05/01';
